import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const PricingSection = () => {
    const { t } = useTranslation();

    const plans = [
        {
            name: t("starter_plan"),
            price: t("starter_price"),
            features: t("starter_features", { returnObjects: true }) as string[]
        },
        {
            name: t("business_plan"),
            price: t("business_price"),
            features: t("business_features", { returnObjects: true }) as string[]
        },
        {
            name: t("enterprise_plan"),
            price: t("enterprise_price"),
            features: t("enterprise_features", { returnObjects: true }) as string[]
        }
    ];
    const waLink = (planName: string): string => {
        return "https://wa.me/85265554706?text="
    + encodeURIComponent("Hi MiChat Team,\n\nI would like to purchase the "+planName+" . Please provide me with more information on how I can get started.\n\nThank you.");
    } 
    return (
        <section id="pricing" className="py-20 bg-gray-50">
            <div className="container mx-auto px-6">
                <h2 className="text-3xl font-bold text-center mb-16">{t("pricing_title")}</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {plans.map((plan, index) => (
                        <motion.div 
                            key={index}
                            initial={{ opacity: 0, scale: 0.95 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5 }}
                            className="bg-white rounded-lg shadow-lg overflow-hidden"
                        >
                            <div className="px-6 py-8 flex flex-col justify-between h-full">
                                <div>
                                    <h3 className="text-2xl font-bold text-center mb-4">{plan.name}</h3>
                                    <div className="text-center mb-6">
                                        <span className="text-xl font-bold">{plan.price}</span>
                                        <span className="text-gray-600">/month</span>
                                    </div>
                                    <ul className="space-y-4 text-left">
                                        {plan.features.map((feature, idx) => (
                                            <li key={idx} className="flex items-center">
                                                <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                                                </svg>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <a href={waLink(plan.name)}>    
                                <button className="w-full bg-blue-500 text-white mt-8 py-3 rounded-lg hover:bg-blue-600 transition duration-300">
                                    {t("get_started")}
                                </button>
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PricingSection;
